import moment from 'moment'

export const split = (arr, n = 1) => {
  var res = []
  while (arr.length) {
    res.push(arr.splice(0, n))
  }
  return res
}

export const getDates = (date, splitNumber = 7) => {
  const today = moment(date)
  const daysInMonth = today.daysInMonth()
  const monthDate = today.startOf('month')

  var dates = []

  for (var i = 0; i < daysInMonth; i++) {
    dates.push(monthDate.clone())
    monthDate.add(1, 'days')
  }

  while (dates[0].day() !== 1) {
    var date1 = dates[0].clone()
    dates.unshift(date1.subtract(1, 'days').clone())
  }

  while (dates[dates.length - 1].day() !== 0) {
    var date2 = dates[dates.length - 1].clone()
    dates.push(date2.add(1, 'days').clone())
  }

  return split(dates, splitNumber)
}

export const isEqualDate = (date1, date2) => {
  date1 = moment(date1)
  date2 = moment(date2)

  if (!date1.isSame(date2, 'year')) {
    return false
  }
  if (!date1.isSame(date2, 'month')) {
    return false
  }
  if (!date1.isSame(date2, 'date')) {
    return false
  }

  return true
}

export const isPeak = (date, dates) => {
  var day = date.day() + ''
  for (var i = 0; i < dates.length; i++) {
    var dateOne = moment(dates[i].startDate)
    var isInRange, matchesDate

    if (dates[i].endDate !== 'endless') {
      var dateTwo = moment(dates[i].endDate)

      isInRange = date.isAfter(dateOne, 'day') && date.isBefore(dateTwo, 'day')
      matchesDate = isEqualDate(dateOne, date) || isEqualDate(dateTwo, date)
    } else {
      isInRange = date.isAfter(dateOne, 'day')
      matchesDate = isEqualDate(dateOne, date)
    }

    if (isInRange || matchesDate) {
      return dates[i][day].peak
    }
  }

  return false
}

export const getTimeslots = (selectedDates, dates) => {
  var highest = 0
  var timeslots = new Map()

  selectedDates.forEach(date => {
    var day = date.day() + ''
    for (var i = 0; i < dates.length; i++) {
      var dateOne = moment(dates[i].startDate)
      var isInRange, matchesDate

      if (dates[i].endDate !== 'endless') {
        var dateTwo = moment(dates[i].endDate)

        isInRange =
          date.isAfter(dateOne, 'day') && date.isBefore(dateTwo, 'day')
        matchesDate = isEqualDate(dateOne, date) || isEqualDate(dateTwo, date)
      } else {
        isInRange = date.isAfter(dateOne, 'day')
        matchesDate = isEqualDate(dateOne, date)
      }

      if (isInRange || matchesDate) {
        for (var j = 0; j < dates[i][day].timeSlots.length; j++) {
          var slot = dates[i][day].timeSlots[j]

          if (timeslots.has(slot)) {
            var amount = timeslots.get(slot) + 1
            highest = highest < amount ? amount : highest

            timeslots.set(slot, amount)
          } else {
            highest = highest === 0 ? 1 : highest
            timeslots.set(slot, 1)
          }
        }
      }
    }
  })

  var timeslotsArray = []
  const keys = Array.from(timeslots.keys())
  keys.forEach(key => {
    var amount = timeslots.get(key)
    if (amount === highest) {
      timeslotsArray.push(key)
    } else {
      timeslotsArray.push(key)
    }
  })

  return timeslotsArray
}

export const keys = [
  { name: 'Peak', style: 'peakKey' },
  { name: 'Off Peak', style: 'notPeakKey' },
  { name: 'Not this month', style: 'notMonthKey' },
  { name: 'Selected', style: 'selectedKey' }
]

export const keys2 = [
  { name: 'Has booking', style: 'hasBooking' },
  { name: 'Not this month', style: 'notMonthKey' },
  { name: 'Selected', style: 'selectedKey' }
]

export const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const slots = [
  '9:00am - 11:00am',
  '10:30am - 12:30pm',
  '11:10am - 13:10pm',
  '12:40pm - 14:40pm',
  '13:20pm - 15:20pm',
  '14:50pm - 16:50pm',
  '15:30pm - 17:30pm'
]

export const getWeekArray = dates => Array(dates.length + 1).fill()
